import { useScope } from "~/hooks/useScope";
import { PlatformPoliciesPage } from "~/pages/platform/policies/PlatformPoliciesPage";

export function PlatformPoliciesEntryPage() {
  const { regionScope } = useScope();
  return regionScope ? <PlatformPoliciesPage scope={regionScope} /> : undefined;
}
